import { gql, TypedDocumentNode } from '@apollo/client'

import { Data } from './types'

export const GET_ASTERIO_BID_TOKEN: TypedDocumentNode<Data> = gql`
  query getAsterioBidToken {
    prebidManagerPublisherToken
  }
`
